module.exports = __webpack_public_path__ + "static/media/home-logo2.e12f5ef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/home-logo2.jpg
// module id = 107
// module chunks = 0